import React from 'react';
import config from 'config';
import { compose } from 'redux';
import { connect } from 'react-redux';
import posthog from 'posthog-js';

import allowOrRedirect from '../allowOrRedirect';
import { startMeasuring } from 'app/utils/stats';
import { TRACK_SEARCH_RESULTS_LOAD } from 'app/constants';
import { loadSearchResults } from 'app/actions/search-results';
import { isHourlyRideSearch } from 'app/sagas/selectors';
import { Layout } from 'app/components/base/Layout';
import HourlyPricingNotice from 'app/components/search-results/HourlyPricingNotice';

import FilterMenu from 'app/components/search-results/FilterMenu';
import { SearchResultsPageProvider } from './SearchResultsPageContext';

/**
 * Mobile search result page that just composes all SRP mobile
 * components together in one Layout.
 * @return {Component}
 */
export default ({ SearchForm, ResultList }) => {
  class SearchResults extends React.Component {
    UNSAFE_componentWillMount() {
      startMeasuring(TRACK_SEARCH_RESULTS_LOAD);
    }

    componentDidMount() {
      this.props.loadSearchResults();
      if (posthog.isFeatureEnabled('record-user-session')) {
        posthog.startSessionRecording();
      }
    }

    render() {
      const { isHourlySearch } = this.props;

      return (
        <SearchResultsPageProvider>
          <Layout
            direction="column"
            size="noshrink"
            align="start stretch"
            nowrap
          >
            <SearchForm />
            <FilterMenu />
            {isHourlySearch && <HourlyPricingNotice />}
            <ResultList />
          </Layout>
        </SearchResultsPageProvider>
      );
    }
  }

  // TODO: move to Flow types
  // SearchResults.propTypes = {
  //   isHourlySearch: PropTypes.bool,
  //   loadSearchResults: PropTypes.func.isRequired
  // };

  const redirectConfig = {
    shouldRedirect: ({ user, isLoading }) =>
      !user && !isLoading && config.ALLOW_ONLY_REGISTERED,
    redirectTo: '/user/login',
  };

  const mapStateToProps = (state) => ({
    isHourlySearch: isHourlyRideSearch(state),
  });

  return compose(
    allowOrRedirect(redirectConfig),
    connect(mapStateToProps, { loadSearchResults })
  )(SearchResults);
};
